export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./cardAnimation.vue?vue&type=template&id=54a883a2&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/cardAnimation.vue?vue&type=template&id=54a883a2&
// module id = null
// module chunks = 